import type { ExternalSiteCheckRule } from "../../types";
import { getNormalizedSixshopHomeUrl } from "./common";
import { SITE_TYPE, SIXSHOP_PAGE } from "./const";

const getSixshopPathname = (siteUrl: string, pathname: string): string => {
  const normalizedSiteUrl = getNormalizedSixshopHomeUrl(siteUrl);

  if (normalizedSiteUrl.includes("sixshop.com")) {
    const originPathnames = new URL(normalizedSiteUrl).pathname.split("/");
    const pathnames = pathname.split("/");
    const newPathname = [...originPathnames, ...pathnames]
      .filter((p) => Boolean(p))
      .join("/");
    return `/${newPathname}`;
  } else {
    const url = new URL(normalizedSiteUrl);
    url.pathname = pathname;

    return url.pathname;
  }
};

const sixshop: ExternalSiteCheckRule = {
  type: SITE_TYPE,

  checkPage({ url, target, siteUrl, html }) {
    if (target.value === "HOME") {
      if (url.pathname === getSixshopPathname(siteUrl, "/")) {
        return true;
      }

      const div = html.querySelector("div#data_div");
      if (!div) {
        return url.pathname === getSixshopPathname(siteUrl, "/home");
      }

      const indexPageLink = div.getAttribute("data-indexPageLink");
      if (indexPageLink) {
        return (
          url.pathname === getSixshopPathname(siteUrl, `/${indexPageLink}`)
        );
      }

      return false;
    }

    if (
      target.value === SIXSHOP_PAGE.LOGIN.target &&
      url.pathname === getSixshopPathname(siteUrl, SIXSHOP_PAGE.LOGIN.url)
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PAGE.SIGNUP.target &&
      url.pathname === getSixshopPathname(siteUrl, SIXSHOP_PAGE.SIGNUP.url)
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PAGE.FIND_PASSWORD.target &&
      url.pathname ===
        getSixshopPathname(siteUrl, SIXSHOP_PAGE.FIND_PASSWORD.url)
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PAGE.MY_PAGE.target &&
      url.pathname === getSixshopPathname(siteUrl, SIXSHOP_PAGE.MY_PAGE.url)
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PAGE.CHECK_GUEST_ORDER.target &&
      url.pathname ===
        getSixshopPathname(siteUrl, SIXSHOP_PAGE.CHECK_GUEST_ORDER.url)
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PAGE.INTRO_ADULT_AUTH.target &&
      url.pathname.startsWith(
        getSixshopPathname(siteUrl, SIXSHOP_PAGE.INTRO_ADULT_AUTH.url)
      )
    ) {
      return true;
    }

    if (target.value === SIXSHOP_PAGE.PRODUCT_CATEGORY.target) {
      const conditionParamValue = target.params?.categoryFilter || "";
      const productCategoryId =
        url.searchParams.get(SIXSHOP_PAGE.PRODUCT_CATEGORY.param) || "";

      if (productCategoryId === conditionParamValue) {
        return true;
      }
    }

    if (target.value === SIXSHOP_PAGE.PRODUCT_DETAIL.target) {
      const conditionPathname = target.params?.productSlug
        ? `${SIXSHOP_PAGE.PRODUCT_DETAIL.url}/${target.params.productSlug}`
        : `${SIXSHOP_PAGE.PRODUCT_DETAIL.url}`;
      if (
        url.pathname.startsWith(getSixshopPathname(siteUrl, conditionPathname))
      ) {
        return true;
      }
    }

    if (
      target.value === SIXSHOP_PAGE.CART.target &&
      url.pathname.startsWith(
        getSixshopPathname(siteUrl, SIXSHOP_PAGE.CART.url)
      )
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PAGE.ORDER.target &&
      url.pathname.startsWith(
        getSixshopPathname(siteUrl, SIXSHOP_PAGE.ORDER.url)
      )
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PAGE.PAYMENT_REQUEST.target &&
      url.pathname.startsWith(
        getSixshopPathname(siteUrl, SIXSHOP_PAGE.PAYMENT_REQUEST.url)
      )
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PAGE.PAYMENT_SUCCESS.target &&
      url.pathname.startsWith(
        getSixshopPathname(siteUrl, SIXSHOP_PAGE.PAYMENT_SUCCESS.url)
      )
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PAGE.POLICY.target &&
      url.pathname === getSixshopPathname(siteUrl, SIXSHOP_PAGE.POLICY.url)
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PAGE.PRIVACY.target &&
      url.pathname === getSixshopPathname(siteUrl, SIXSHOP_PAGE.PRIVACY.url)
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PAGE.SIGNUP_PRIVACY.target &&
      url.pathname ===
        getSixshopPathname(siteUrl, SIXSHOP_PAGE.SIGNUP_PRIVACY.url)
    ) {
      return true;
    }

    return false;
  },
};

export default sixshop;
